// types
import type { Suggestion } from '../../locator.types';

// components
import SuggestItem from './suggest-item';

// utils
import { isEmpty } from 'utils/is-empty';

interface SuggestListProps {
  isHidden: boolean;
  suggests: Suggestion[] | null;
  selectSuggest: (suggest?: Suggestion) => void;
  cursor: number;
}

export function SuggestList({
  isHidden,
  suggests,
  selectSuggest,
  cursor,
}: Readonly<SuggestListProps>) {
  return (
    !isHidden &&
    !isEmpty(suggests) &&
    suggests.map((suggest, index) => (
      <SuggestItem
        key={suggest.placeId}
        index={index}
        suggest={suggest}
        selectSuggest={selectSuggest}
        cursor={cursor}
      />
    ))
  );
}
